export default __webpack_public_path__ + "static/media/github.e861751d.svg";